import { defineComponent as _defineComponent } from 'vue';
import { library } from "@fortawesome/fontawesome-svg-core";
import { faPlus, faUpload } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { BButton } from "bootstrap-vue";
import { storeToRefs } from "pinia";
import { computed } from "vue";
import { useRouter } from "vue-router/composables";
import { useUserStore } from "@/stores/userStore";
export default /*#__PURE__*/ _defineComponent({
    __name: 'WorkflowListActions',
    setup(__props) {
        library.add(faPlus, faUpload);
        const router = useRouter();
        const userStore = useUserStore();
        const { isAnonymous } = storeToRefs(userStore);
        const createButtonTitle = computed(() => {
            if (isAnonymous.value) {
                return "Log in to create workflow";
            }
            else {
                return "Create new workflow";
            }
        });
        const importButtonTitle = computed(() => {
            if (isAnonymous.value) {
                return "Log in to import workflow";
            }
            else {
                return "Import workflow from URL or file";
            }
        });
        function navigateToImport() {
            router.push("/workflows/import");
        }
        function navigateToOldCreate() {
            router.push("/workflows/edit");
        }
        return { __sfc: true, router, userStore, isAnonymous, createButtonTitle, importButtonTitle, navigateToImport, navigateToOldCreate, faPlus, faUpload, FontAwesomeIcon, BButton };
    }
});
